import {BrowserRouter, Route, Routes} from "react-router-dom";
import Main from "./main";
import KnowME from "./Know_ME";
import ScrollToTop from "./ScrollToTop";

const Routing=()=>{
    return(
        <BrowserRouter>
         <ScrollToTop />
        <Routes>
            <Route path='/' element={<Main/>}/>
            <Route path='/know-me' element={<KnowME/>}/>
        </Routes>
        </BrowserRouter>
    )
}

export default Routing;